"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var dropdownConstants_1 = require("./dropdownConstants");

var InternalDropdownItem_1 = require("./InternalDropdownItem");

var Divider_1 = require("../Divider");

exports.DropdownSeparator = function (_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      ref = _a.ref,
      props = tslib_1.__rest(_a, ["className", "ref"]);

  return React.createElement(dropdownConstants_1.DropdownArrowContext.Consumer, null, function (context) {
    return React.createElement(InternalDropdownItem_1.InternalDropdownItem, Object.assign({}, props, {
      context: context,
      component: React.createElement(Divider_1.Divider, {
        component: Divider_1.DividerVariant.div
      }),
      className: className,
      role: "separator"
    }));
  });
};

exports.DropdownSeparator.displayName = 'DropdownSeparator';